import { index, sqliteTable, text } from 'drizzle-orm/sqlite-core'

import { id, timestamps } from './_columns'

export const consoleAudit = sqliteTable(
  'audit_log',
  {
    id: id(),
    staffId: text('staff_id'),
    /** e.g. `staff.create`, `site.register`, `site.plan.change`, `site.sso` */
    action: text('action').notNull(),
    entity: text('entity').notNull(),
    entityId: text('entity_id'),
    /** Short human detail, e.g. `business → advanced`. */
    detail: text('detail'),
    createdAt: timestamps.createdAt,
  },
  (t) => [index('ix_console_audit_created_at').on(t.createdAt), index('ix_console_audit_entity').on(t.entity, t.entityId)],
)
